import { NotificationDto } from '../dto/notifications.dto'
import { NotificationModel, NotificationType, PlatformType } from '../models/notifications.model'

const fromDtoToModelTransformer = (dto: NotificationDto): NotificationModel[] => {
  return dto.id.map((id, index) => ({
    id,
    // TODO: Implement a failsafe to handle new Types from Backend
    type: dto.type[index] || NotificationType.Optional,
    text: dto.text[index] || '',
    isUser: Boolean(dto.user[index]) || false,
    isInstaller: Boolean(dto.installer[index]) || false,
    isPartner: Boolean(dto.partner[index]) || false,
    isExtService: Boolean(dto.ext_service[index]) || false,
    isE3dcService: Boolean(dto.e3dc_service[index]) || false,
    isE3dcRoot: Boolean(dto.e3dc_root[index]) || false,
    isE3dcAdmin: Boolean(dto.e3dc_admin[index]) || false,
    title: dto.title[index] || '',
    platform: dto.platform[index] || PlatformType.Both,
    startAt: new Date(dto.startAt[index]),
    stopAt: dto.stopAt[index] ? new Date(dto.stopAt[index]) : null,
    readAt: dto.readAt[index] ? new Date(dto.readAt[index]) : null,
    createdAt: new Date(dto.createdAt[index]),
  }))
}

export default fromDtoToModelTransformer
